$(document).on('click', '.product-actions .increase', function () {
    var elCount = $(this).parent().find('.count');
    var count = parseInt(elCount.val());

    if (elCount.attr('data-maximum')){
        count = Math.min(parseInt(elCount.attr('data-maximum')), count+1)
    }else{
        count++;
    }

    $('.quantity-input').val(count);
    elCount.val(count);
    $(this).prev().text(count);
    App.prototype.calculateProductPrice($(this).closest('form'));
});

$(document).on('click', '.product-actions .decrease', function () {

    var elCount = $(this).parent().find('.count');
    var count = parseInt(elCount.val());

    if (count > 1) {

        if (elCount.attr('data-minimum')){
            count = Math.max(parseInt(elCount.attr('data-minimum')), count-1)
        }else{
            count--;
        }

        $('.quantity-input').val(count);
        elCount.val(count);
        $(this).next().text(count);
        App.prototype.calculateProductPrice($(this).closest('form'));
    }
});

$("body").on("keyup",".product-actions .count",function(){

    var elCount = $(this).parent().find('.count');
    var count = parseInt(elCount.val());

    if (elCount.attr('data-maximum')){
        count = Math.min(parseInt(elCount.attr('data-maximum')), count)
    }else{
        count = Math.max(1, count)
    }

    $('.quantity-input').val(count);
    elCount.val(count);
    //$(this).prev().text(count);

});
